export default class UserInvoiceSettingsOrder {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.form = document.getElementById('userInvoiceDataFormOrder');
    this.orderForm = document.getElementById('dashboardMakeOrder');

    if (!this.form) return;

    this.action = this.form.getAttribute('data-action');
    this.elements = this.form.querySelectorAll('input');

    this.submit = document.getElementById('submitInvoice');

    this.formWrapper = document.getElementById('invoiceForm');
    this.checkbox = document.getElementById('invoice');
    this.checkbox2 = document.getElementById('bill');

    this.rules = {
      invoice_tax_number: {
        rule: new RegExp("^[0-9]{9,12}$"),
        message: 'Numer jest niepoprawny'
      },
      invoice_postal: {
        rule: new RegExp("[0-9]{2}\-[0-9]{3}"),
        message: 'Kod pocztowy jest niepoprawny'
      }
    }

    this.optionalRules = {
      invoice_name: {
        rule: 'required',
        message: 'To pole jest wymagane',
      },
      invoice_mail: {
        rule: 'required',
        message: 'To pole jest wymagane',
      },
      // invoice_tax_number_type: {
      //   rule: 'placeholder',
      //   message: 'To pole jest wymagane',
      // },
      invoice_tax_number: {
        rule: 'required',
        message: 'To pole jest wymagane',
      },
      invoice_street: {
        rule: 'required',
        message: 'To pole jest wymagane',
      },
      invoice_city: {
        rule: 'required',
        message: 'To pole jest wymagane',
      },
      invoice_postal: {
        rule: 'required',
        message: 'To pole jest wymagane',
      },
      invoice_home_number: {
        rule: 'required',
        message: 'To pole jest wymagane',
      },
    };

    this.errors = [];

    return true;
  }

  setupEvents() {
    this.submit.addEventListener('click', evt => this.handleSubmit(evt));
    // this.form.addEventListener('submit', (evt) => this.handleSubmit(evt));
    this.checkbox.addEventListener('change', () => {
      if (this.checkbox.checked) {
        this.formWrapper.style.display = '';
      }
    });

    this.checkbox2.addEventListener('change', () => {
      if (this.checkbox2.checked) {
        this.formWrapper.style.display = 'none';
      }
    })
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.clearValidationErrors();

    const data = this.buildData();

    if (!this.errors.length) {
      this.send(data);
    } else {
      this.throwValidationError();
    }
  }

  buildData() {
    let data = {};

    for (let i = 0; i < this.elements.length; i++) {
      const el = this.elements[i];

      if (el.getAttribute('type') !== 'submit') {
        const key = el.getAttribute('name');
        const val = (el.value !== 'placeholder') ? el.value : '';
        this.validate(key, val);

        if (this.orderForm) {
          this.optionlValidation(key, val);
        }

        data[key] = val;
      }
    }
    data['invoice_tax_number_type'] = 'N';

    return data;
  }

  send(data) {
    axios.post(this.action, data)
    .then((response) => {
      if (response && response.data.code === 200) {
        document._kweber.toast({
          type: 'success',
          title: 'Ustawienia zapisane!'
        });
      } else {
        throw new Error(response);
      }
    })
    .catch((error) => {
      document._kweber.toast({
        type: 'error',
        title: 'Błąd zapisu, spróbuj ponownie'
      });
    });
  }

  validate(key, val) {
    if (this.rules[key] !== undefined && val.length) {
      if (!val.match(this.rules[key].rule)) {
        const error = {
          name: key,
          msg: this.rules[key].message
        };
        this.errors.push(error);
      }
    }
  }

  optionlValidation(key, val) {
    if (this.optionalRules[key] !== undefined) {
      if (this.optionalRules[key].rule === 'placeholder') {
        if (val === 'placeholder') {
          const error = {
            name: key,
            msg: this.optionalRules[key].message
          };
          this.errors.push(error);
        }
      } else if (this.optionalRules[key].rule === 'required') {
        if (!val.length) {
          const error = {
            name: key,
            msg: this.optionalRules[key].message
          };
          this.errors.push(error);
        }
      }
    }
  }

  throwValidationError() {
    this.errors.forEach((error) => {
      const field = this.elements.namedItem(error.name);
      const node = field.closest('div');
      field.classList.add('form-invalid-right');
      node.appendChild(this.getErrorNode(error.name, error.msg));
    });
  }

  clearValidationErrors() {
    this.errors = [];
    const errorNodes = this.form.getElementsByClassName('form-error');
    const errorFields = this.form.getElementsByClassName('form-invalid-right');
    Array.from(errorNodes).forEach((node) => {
      node.remove();
    });

    Array.from(errorFields).forEach((field) => {
      field.classList.remove('form-invalid-right');
    });
  }

  getErrorNode(key, msg) {
    const label = document.createElement("label");
    label.setAttribute('for', key);
    label.classList.add('form-error');
    label.classList.add('form-invalid-right');
    label.innerText = msg;
    return label;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/UserInvoiceSettingsOrder.js